import { render } from "./pageModel.vue?vue&type=template&id=dd4318d4"
import script from "./pageModel.vue?vue&type=script&lang=js"
export * from "./pageModel.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__